import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLoggedIn } from '../utils/utilities';

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route
      {...rest}
      render={props =>
        isLoggedIn() && restricted ? (
          <Redirect to="/service_professional/bookings" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
